module.exports = __webpack_public_path__ + "img/Banner2-1.445aaedd.jpg";